package dev.danko.roblox_craft_ai.pages

import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.FlexWrap
import com.varabyte.kobweb.compose.ui.styleModifier
import dev.danko.roblox_craft_ai.uikit.icons.Icon
import dev.danko.roblox_craft_ai.uikit.icons.AppIcon
import org.jetbrains.compose.web.dom.Article
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H1
import dev.danko.roblox_craft_ai.components.SiteSection
import dev.danko.roblox_craft_ai.components.SiteHeader
import dev.danko.roblox_craft_ai.components.SiteFooter
import dev.danko.roblox_craft_ai.uikit.components.LanguageSwitcher
import dev.danko.roblox_craft_ai.state.Txt
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.grid
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.components.icons.fa.FaRobot
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.danko.roblox_craft_ai.components.HealthStatusBadge
import dev.danko.roblox_craft_ai.components.layouts.PageLayoutData
import dev.danko.roblox_craft_ai.shared.model.AssetType
import dev.danko.roblox_craft_ai.shared.model.PresetCategory
import dev.danko.roblox_craft_ai.shared.model.PresetDifficulty
import dev.danko.roblox_craft_ai.shared.model.PresetSeeds
import dev.danko.roblox_craft_ai.uikit.i18n.LocaleController
import dev.danko.roblox_craft_ai.shared.model.PromptPresetDto
import dev.danko.roblox_craft_ai.shared.repository.PersonalPresetRepositoryJs
import dev.danko.roblox_craft_ai.uikit.components.AppButton
import dev.danko.roblox_craft_ai.uikit.components.AppButtonSize
import dev.danko.roblox_craft_ai.uikit.components.AppButtonVariant
import dev.danko.roblox_craft_ai.uikit.components.AppCard
import dev.danko.roblox_craft_ai.uikit.components.AppInput
import dev.danko.roblox_craft_ai.uikit.components.ModalDialog
import dev.danko.roblox_craft_ai.uikit.components.ModalDialogConfirmActions
import dev.danko.roblox_craft_ai.uikit.components.ToastManager
import dev.danko.roblox_craft_ai.uikit.theme.LocalAppTheme
import dev.danko.roblox_craft_ai.uikit.theme.toAppPalette
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh

private fun presetCategoriesDisplay(): List<Pair<PresetCategory?, Pair<String, String>>> = listOf(
    null to ("🌐" to Txt.presetsPage.categoryAll),
    PresetCategory.ENVIRONMENT to ("🏠" to Txt.presetsPage.categoryEnvironment),
    PresetCategory.NPC to ("🧑‍🦱" to Txt.presetsPage.categoryNpc),
    PresetCategory.INTERIOR to ("🪑" to Txt.presetsPage.categoryInterior),
    PresetCategory.WEAPON to ("⚔️" to Txt.presetsPage.categoryWeapon),
    PresetCategory.ITEM to ("🎒" to Txt.presetsPage.categoryItem),
    PresetCategory.ANIMATION to ("🎬" to Txt.presetsPage.categoryAnimation),
    PresetCategory.SCRIPT to ("🧪" to Txt.presetsPage.categoryScript),
    PresetCategory.PERSONAL to ("👤" to Txt.presetsPage.categoryPersonal)
)

// A plain grid container: Kobweb's Box stacks every child in the same cell, which hid all cards but one.
val PromptsGridStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Grid)
            .gap(1.cssRem)
            .styleModifier { property("grid-template-columns", "repeat(auto-fill, minmax(280px, 1fr))") }
    }
}

private val PersonalRepo: PersonalPresetRepositoryJs = PersonalPresetRepositoryJs()

private val SessionJson = Json { ignoreUnknownKeys = true; encodeDefaults = true }

@InitRoute
@Suppress("unused")
fun initPromptsPage(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Txt.presetsPage.pageTitle))
}

fun PresetDifficulty.label(): String = when (this) {
    PresetDifficulty.EASY -> Txt.presetsPage.difficultyEasy
    PresetDifficulty.MEDIUM -> Txt.presetsPage.difficultyMedium
    PresetDifficulty.HARD -> Txt.presetsPage.difficultyHard
}

@Composable
fun PresetDifficulty.color(): Color {
    val palette = LocalAppTheme.current.colors
    return when (this) {
        PresetDifficulty.EASY -> palette.statusReady
        PresetDifficulty.MEDIUM -> palette.statusPending
        PresetDifficulty.HARD -> palette.statusFailed
    }
}

@Page("/prompts")
@Composable
fun PromptsPage() {
    val theme = LocalAppTheme.current
    val palette = theme.colors
    val scope = rememberCoroutineScope()

    var colorMode by ColorMode.currentState
    var selectedCategory: PresetCategory? by remember { mutableStateOf(null) }
    var searchQuery by remember { mutableStateOf("") }
    var debouncedSearch by remember { mutableStateOf("") }
    var personalPresets by remember { mutableStateOf<List<PromptPresetDto>>(emptyList()) }
    var deleteConfirmId by remember { mutableStateOf<String?>(null) }

    LaunchedEffect(Unit) {
        personalPresets = PersonalRepo.getAll()
    }

    LaunchedEffect(searchQuery) {
        delay(200)
        debouncedSearch = searchQuery
    }

    val combinedList: List<PromptPresetDto> = remember(personalPresets) {
        val public = PresetSeeds.ALL
        val personalMarked = personalPresets.map { it.copy(category = PresetCategory.PERSONAL, author = Txt.common.you, isPublic = false) }
        public + personalMarked
    }

    val localeCode = LocaleController.current.code
    val filtered: List<PromptPresetDto> = remember(combinedList, selectedCategory, debouncedSearch, localeCode) {
        var list = combinedList
        val cat = selectedCategory
        if (cat != null) {
            list = list.filter { it.category == cat }
        }
        val q = debouncedSearch.trim().lowercase()
        if (q.isNotBlank()) {
            list = list.filter { p ->
                p.localizedTitle(localeCode).lowercase().contains(q) ||
                    p.localizedDescription(localeCode).lowercase().contains(q) ||
                    p.tags.any { t -> t.lowercase().contains(q) }
            }
        }
        list
    }

    val showPersonalEmpty = selectedCategory == PresetCategory.PERSONAL && filtered.isEmpty()

    Box(Modifier.fillMaxWidth().minHeight(100.vh).backgroundColor(palette.background)) {
        Column(Modifier.fillMaxSize()) {
            SiteHeader(SiteSection.IDEAS, subtitle = Txt.presetsPage.subtitle)

            Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.TopCenter) {
                Column(Modifier.fillMaxWidth().maxWidth(1280.px).padding(topBottom = 32.px, leftRight = 20.px).gap(20.px)) {
                    H1(Modifier.margin(0.px).fontSize(32.px).fontWeight(FontWeight.ExtraBold).color(palette.textPrimary)
                        .styleModifier { property("letter-spacing", "-0.02em") }.toAttrs()) {
                        Text(Txt.presetsPage.subtitle.removePrefix("📚 "))
                    }
                    Row(Modifier.fillMaxWidth().gap(6.px).flexWrap(FlexWrap.Wrap)) {
                        presetCategoriesDisplay().forEach { (cat, display) ->
                            val count = if (cat == null) PresetSeeds.ALL.size + personalPresets.size else combinedList.count { it.category == cat }
                            AppButton(
                                text = "${display.second} · $count",
                                variant = if (selectedCategory == cat) AppButtonVariant.PRIMARY else AppButtonVariant.OUTLINE,
                                size = AppButtonSize.SM,
                                modifier = Modifier.borderRadius(999.px),
                                onClick = { selectedCategory = cat }
                            )
                        }
                    }
                    Row(Modifier.fillMaxWidth().gap(12.px).flexWrap(FlexWrap.Wrap), verticalAlignment = Alignment.CenterVertically) {
                        Box(Modifier.flexGrow(1).minWidth(240.px)) {
                            AppInput(
                                value = searchQuery,
                                onValueChanged = { searchQuery = it },
                                label = null,
                                placeholder = Txt.presetsPage.searchPlaceholder.removePrefix("🔍 "),
                                modifier = Modifier.fillMaxWidth()
                            )
                        }
                        SpanText(Txt.presetsPage.found(filtered.size), Modifier.fontSize(14.px).color(palette.textSecondary))
                    }

                    if (showPersonalEmpty) {
                        AppCard(Modifier.fillMaxWidth()) {
                            Column(
                                Modifier
                                    .fillMaxWidth()
                                    .padding(2.cssRem)
                                    .gap(0.75.cssRem),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                SpanText("👤", Modifier.fontSize(2.5.cssRem).opacity(0.7f))
                                SpanText(
                                    Txt.presetsPage.noPersonalTitle,
                                    Modifier.fontSize(1.05.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary)
                                )
                                SpanText(
                                    Txt.presetsPage.noPersonalHint,
                                    Modifier
                                        .fontSize(0.85.cssRem)
                                        .color(palette.textSecondary)
                                        .textAlign(TextAlign.Center)
                                        .maxWidth(36.cssRem)
                                        .lineHeight(1.4)
                                )
                                AppButton(
                                    text = Txt.presetsPage.goToStudio,
                                    variant = AppButtonVariant.PRIMARY,
                                    size = AppButtonSize.MD,
                                    onClick = { window.location.href = "/" }
                                )
                            }
                        }
                    } else if (filtered.isEmpty() && debouncedSearch.isNotBlank()) {
                        AppCard(Modifier.fillMaxWidth()) {
                            Column(
                                Modifier.fillMaxWidth().padding(2.cssRem).gap(0.5.cssRem),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                SpanText("🔍", Modifier.fontSize(2.cssRem).opacity(0.7f))
                                SpanText(
                                    Txt.presetsPage.nothingFound(debouncedSearch),
                                    Modifier.fontSize(0.9.cssRem).fontWeight(FontWeight.SemiBold).color(palette.textPrimary)
                                )
                                SpanText(
                                    Txt.presetsPage.nothingFoundHint,
                                    Modifier.fontSize(0.78.cssRem).color(palette.textSecondary)
                                )
                            }
                        }
                    } else {
                        Div(PromptsGridStyle.toModifier().fillMaxWidth().toAttrs()) {
                            filtered.forEach { preset ->
                                PresetCard(
                                    preset = preset,
                                    onUse = { usePresetForNavigate(preset) },
                                    onDelete = if (preset.category == PresetCategory.PERSONAL) {
                                        { deleteConfirmId = preset.id }
                                    } else null
                                )
                            }
                        }
                    }
                }
            }

            SiteFooter()
        }
    }

    val toDeleteId = deleteConfirmId
    val toDelete = remember(toDeleteId, personalPresets) {
        personalPresets.firstOrNull { it.id == toDeleteId }
    }
    if (toDelete != null) {
        ModalDialog(
            visible = true,
            onCloseRequest = { deleteConfirmId = null },
            title = Txt.presetsPage.deleteTitle,
            footer = ModalDialogConfirmActions(
                confirmText = Txt.common.delete,
                cancelText = Txt.common.cancel,
                confirmVariant = AppButtonVariant.DANGER,
                onConfirm = {
                    scope.launch(Dispatchers.Default) {
                        val ok = PersonalRepo.delete(toDelete.id)
                        if (ok) {
                            personalPresets = PersonalRepo.getAll()
                            ToastManager.success(Txt.presetsPage.deleted(toDelete.localizedTitle(LocaleController.current.code)))
                        }
                        deleteConfirmId = null
                    }
                },
                onCancel = { deleteConfirmId = null }
            )
        ) {
            SpanText(
                Txt.presetsPage.deleteConfirm(toDelete.localizedTitle(LocaleController.current.code)),
                Modifier.fontSize(0.88.cssRem).color(palette.textPrimary)
            )
        }
    }
}

private fun usePresetForNavigate(preset: PromptPresetDto) {
    try {
        val json = SessionJson.encodeToString(preset)
        window.sessionStorage.setItem("robloxCraft.pendingPreset", json)
    } catch (_: Throwable) { }
    window.location.href = "/"
}

@Composable
private fun PresetCard(
    preset: PromptPresetDto,
    onUse: () -> Unit,
    onDelete: (() -> Unit)? = null
) {
    val palette = LocalAppTheme.current.colors
    val locale = LocaleController.current.code
    val catLabel = if (preset.category == PresetCategory.PERSONAL) Txt.presetsPage.categoryPersonal
    else presetCategoriesDisplay().firstOrNull { it.first == preset.category }?.second?.second ?: Txt.presetsPage.categoryOther
    val typeIcon = when (preset.preferredAssetType) {
        AssetType.LUAU_SCRIPT -> AppIcon.CODE
        AssetType.MESH_3D -> AppIcon.CUBE
        AssetType.ANIMATION -> AppIcon.FIGURE
        AssetType.ROJO_PROJECT -> AppIcon.FOLDER
        else -> AppIcon.SPARKLES
    }

    Article(
        Modifier
            .fillMaxWidth()
            .padding(18.px)
            .borderRadius(16.px)
            .border(1.px, LineStyle.Solid, palette.border)
            .backgroundColor(palette.surface)
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .gap(12.px)
            .toAttrs()
    ) {
        Row(Modifier.fillMaxWidth().gap(10.px), verticalAlignment = Alignment.CenterVertically) {
            Box(
                Modifier.size(36.px).flexShrink(0).borderRadius(10.px).backgroundColor(palette.surfaceElevated).color(palette.accentText),
                contentAlignment = Alignment.Center
            ) { Icon(typeIcon, size = 18) }
            Column(Modifier.flexGrow(1).minWidth(0.px).gap(2.px)) {
                H3(Modifier.margin(0.px).fontSize(15.px).fontWeight(FontWeight.Bold).lineHeight(1.3).color(palette.textPrimary).toAttrs()) {
                    Text(preset.localizedTitle(locale))
                }
                SpanText(catLabel, Modifier.fontSize(12.px).color(palette.textSecondary))
            }
            SpanText(
                preset.difficulty.label(),
                Modifier.height(24.px).padding(leftRight = 10.px).borderRadius(999.px).fontSize(12.px).fontWeight(FontWeight.SemiBold)
                    .backgroundColor(preset.difficulty.color().toRgb().copy(alpha = 36)).color(preset.difficulty.color())
                    .display(DisplayStyle.Flex).alignItems(AlignItems.Center).flexShrink(0)
            )
        }
        SpanText(
            preset.localizedDescription(locale),
            Modifier.fontSize(14.px).color(palette.textSecondary).lineHeight(1.5).flexGrow(1)
        )
        if (preset.tags.isNotEmpty()) {
            Row(Modifier.gap(6.px).flexWrap(FlexWrap.Wrap)) {
                preset.tags.take(3).forEach { tag ->
                    SpanText("#$tag", Modifier.fontSize(12.px).color(palette.textSecondary).padding(topBottom = 2.px, leftRight = 8.px)
                        .borderRadius(999.px).backgroundColor(palette.background))
                }
            }
        }
        Row(Modifier.fillMaxWidth().gap(8.px), verticalAlignment = Alignment.CenterVertically) {
            if (onDelete != null) {
                AppButton(
                    text = "",
                    icon = AppIcon.TRASH,
                    ariaLabel = Txt.common.delete,
                    variant = AppButtonVariant.GHOST,
                    size = AppButtonSize.SM,
                    modifier = Modifier.width(36.px).padding(0.px),
                    onClick = onDelete
                )
            }
            Spacer()
            AppButton(text = Txt.presetsPage.usePrompt, icon = AppIcon.SPARKLES, size = AppButtonSize.SM, onClick = onUse)
        }
    }
}
